import stripeHandler from "../utils/stripeHandler";

export default {
	namespace: 'membership-checkout',
	beforeEnter(barba) {

	},
	afterEnter(barba) {
		const header = document.querySelector('header.site-header')
		header.classList.add('membership-header')
		console.log('View: membership payment')

		// Kick off Stripe:
		stripeHandler(barba.next.container)
	},
	beforeLeave(barba) {

	},
	afterLeave(barba) {
		const header = document.querySelector('header.site-header')
		header.classList.remove('membership-header')
	}
}
